import { ApiError } from '@/api/client';
import { intelligenceFeatures } from '@/shared/config/intelligence-features';

/** The environment switch can disable legacy surfaces, but cannot establish host support. */
export function legacyCapsuleSurfacesEnabled(
  capsule: { legacyZoneSurfaces?: boolean } | undefined
): boolean {
  return capsule?.legacyZoneSurfaces === true && intelligenceFeatures.legacyZoneSurfaces();
}

export function isLegacyCapsuleTab(tab: string | null): boolean {
  return ['vocabulary', 'overrides', 'schema', 'sources', 'streams'].includes(tab ?? '');
}

export function isTerminalIntelligenceError(error: unknown): boolean {
  return error instanceof ApiError && error.serverRetryable === false;
}

export function isRetiredIntelligenceError(error: unknown): boolean {
  return (
    isTerminalIntelligenceError(error) &&
    error instanceof ApiError &&
    typeof error.data === 'object' &&
    error.data !== null &&
    'error' in error.data &&
    error.data.error === 'intelligence_surface_retired'
  );
}

export const legacyIntelligenceQueryPolicy = {
  retry: (failureCount: number, error: unknown) =>
    !isTerminalIntelligenceError(error) && failureCount < 1,
} as const;
